module.exports = __webpack_public_path__ + "static/media/money-mouth-face-svgrepo-com.03cbdc30.svg";